import * as styledEl from './Accordion.styled'

export const Accordion = {
  Root: styledEl.Root,
  Item: styledEl.Item,
  Header: styledEl.Header,
  Trigger: styledEl.Trigger,
  Panel: styledEl.Panel,
  Chevron: styledEl.Chevron,
}
